import { Flex, Skeleton, theme } from 'antd';

const SKELETON_MAX_WIDTH = 280;

const LoaderEcho = () => {
  const { token } = theme.useToken();

  return (
    <Flex
      data-testid="loader"
      vertical
      style={{
        width: '100%',
        maxWidth: SKELETON_MAX_WIDTH,
        padding: token.paddingLG,
        boxSizing: 'border-box',
      }}
    >
      <Skeleton
        active
        title={false}
        paragraph={{ rows: 3, width: ['60%', '100%', '80%'] }}
        styles={{ root: { width: '100%' } }}
      />
    </Flex>
  );
};

export default LoaderEcho;
